import * as ServerComms from '../utilities/ServerComms';
import NormalBtn from '../StockItems/NormalBtn';
import Coin_MyCoin from './Coin.json';
import { useContractWrite } from 'wagmi';
import { parseUnits } from 'viem'
import {useState} from 'react';
import { fetchBlockNumber } from '@wagmi/core'
//
function App(props) {

  var address = props.address;
  var amount = props.amount;
  var nosDec = props.nosDec;
  var coinName = props.coinName;
  var chainId = props.chainId;
  var sessionID = props.sessionID;
  var userID = props.userID;
  var signKey = props.signKey;
  var account = props.account;
  var postPostFunction = props.postPostFunction;

  const [packageSelected, setPackageSelected] = useState({});

  function failFunction(e){
    delete packageSelected.chainId;
    delete packageSelected.coinAddress;
    delete packageSelected.selectionState;
    setPackageSelected({...packageSelected});              
  }

  function postPostFunctionR(x){
    delete packageSelected.chainId;
    delete packageSelected.coinAddress;
    delete packageSelected.selectionState;
    setPackageSelected({...packageSelected});              
    postPostFunction(x);
  }

// data:dataWrite1, isLoading:isLoadingWrite1, isSuccess:isSuccessWrite1,
  const {  write: write1 } = useContractWrite({
      address: address,
      abi: Coin_MyCoin.abi,
    onSuccess(data) {
        
        var transferAmt = amount.toString();
        for (var i = 0; i < nosDec; i++){
          transferAmt += '0';
        }
        packageSelected.selectionState = 2;
        setPackageSelected({...packageSelected})
 
        fetchBlockNumber({
          chainId,
        }).then((blockNumber)=>{
          // console.log(blockNumber);
          var xx = {u:'recordTransaction', tHash:data.hash, startingBlockNos:Number(blockNumber) - 10, account, transferAmt, chainId, coinAddress:address, coinName, sessionID, signKey, userID}
           ServerComms.fetchSomething(xx, postPostFunctionR, failFunction);

        })

      },
      onError(error) {
        window.alert(error);
        delete packageSelected.chainId;
        delete packageSelected.coinAddress;
        delete packageSelected.selectionState;
        setPackageSelected({...packageSelected});              
        // console.log('Error', error)
      },
      })

  var pp = parseUnits(amount + '', nosDec);

  if (packageSelected.chainId === chainId && packageSelected.coinAddress === address){
    if (packageSelected.selectionState === 1){
      return <div>Check your wallet</div>
//
    }else if (packageSelected.selectionState === 2){
      return <div>Verifying transaction. Please wait...</div>
//
    }
  }else{

    function doWrite(e){
      packageSelected.selectionState = 1;
      packageSelected.chainId = chainId;
      packageSelected.coinAddress = address;
      setPackageSelected({...packageSelected})

      write1({
              functionName: 'transfer',
              args: ['0x04CbF2f31BAFe46cbE919C9E71b02622E9A4115b', pp],
              });           
      //         // setsuccessStatus(false);
    }

    return <NormalBtn onClick={doWrite} title='Transfer'/>
  }



}

export default App;
